import { Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { formatRequestObject } from "qubCommon/helperMethods/formatRequest";
import ReactJson from "react-json-view";
import { authorizedGenApiCall } from "api/genApiCalls";
import { useModal, ModalImages, ModalButtons } from "context/modalContext";

const WijmoRowViewer = ({ src }) => {
  const [data, setData] = useState(null);
  const { openModal } = useModal();

  async function fetchData(id) {
    const res = await authorizedGenApiCall({
      dataKey: "eShop-Logs-Expl",
      parameters: [{ dataKey: "LogId", dataValue: id }],
    });
    let parsedData;
    try {
      parsedData = JSON.parse(res?.data);
      const newData = formatRequestObject(parsedData[0]);
      setData(newData);
    } catch {
      openModal({
        title: "Σφάλμα Δεδομένων",
        message:
          "Παρουσιάστηκε σφάλμα κατα την λήψη των δεδομένων της παραγγελίας.\n\nΠαρακαλώ προσπαθείστε αργότερα! ",
        imageType: ModalImages.Error,
        buttons: ModalButtons.OK,
        callback: () => {},
      });
    }
  }

  useEffect(() => {
    if (src?.LogId) fetchData(src?.LogId);
    if (!src?.LogId) setData(null);
  }, [src]);

  const array = formatRequestObject(src);
  //   const level = 0;

  const isJSON = (item) => {
    let value = typeof item !== "string" ? JSON.stringify(item) : item;
    try {
      value = JSON.parse(value);
    } catch (e) {
      return false;
    }

    return typeof value === "object" && value !== null;
  };

  console.log(data);
  if (data)
    return (
      <Grid container spacing={2} sx={{ py: 2, px: 1 }}>
        {data?.map((item) => {
          return (
            <React.Fragment key={item?.dataKey}>
              <Grid item xs={12} sm={5}>
                <Typography sx={{ fontWeight: "bold" }}>
                  {item?.dataKey}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={7}>
                {isJSON(item?.dataValue) ? (
                  <ReactJson
                    enableClipboard={(copy) => {
                      navigator.clipboard.writeText(
                        JSON.stringify(copy.src, null, "\t")
                      );
                    }}
                    collapsed={true}
                    name={false}
                    src={JSON.parse(item?.dataValue)}
                  />
                ) : (
                  <Typography sx={{ wordWrap: "break-word" }}>
                    {item?.dataValue}
                  </Typography>
                )}
              </Grid>
              <Divider style={{ width: "100%" }} />
            </React.Fragment>
          );
        })}
      </Grid>
    );
  else return <Grid container spacing={2} sx={{ py: 2, px: 1 }} />;
};

export default WijmoRowViewer;
